
<template src="./TechnicalManager.html"></template>


<script>
import mixins from "../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      specialtiesAddDoctor: [],
      doctorsAdd: [],
      newDoctorsAdd: [],
      doctorAddTemp: { name: "", crmNumber: "", crmState: "", email: "", cpf: ""},
      countAddSpecialtyDoctor: 0,
      specialties: [],
      popupAddDoctor: false,
      titlePopUp: "",
      doctorsTemp: [],
      popupIsEditDoctor: false,
      specialtiesDoctorTable: [],
      specialtiesDoctorTableFinal: [],
      popupAddLinkedDoctor: false,
      typedWord: "",
      doctorsSearch: [],
      disabledConfirmButton: true,
      doctorSelected: [],
      doctorId: null,
      notSchedule: false,
      doctorAttendanceDataAdd: [],
      specialtiesDoctorTableTemp: [],
      webClinic: {},
      actualTechnicalManager: null,
      optionsWeekDays: [
        {
          text: "Seg",
          value: "MONDAY"
        },
        {
          text: "Ter",
          value: "TUESDAY"
        },
        {
          text: "Quar",
          value: "WEDNESDAY"
        },
        {
          text: "Qui",
          value: "THURSDAY"
        },
        {
          text: "Sex",
          value: "FRIDAY"
        },
        {
          text: "Sáb",
          value: "SATURDAY"
        }
      ]
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getSpecialties();
      vm.getDoctors();
    },
    clickAddNewDoctor() {
      const vm = this;
      vm.popupAddDoctor = true;
      vm.popupIsEditDoctor = false;
      vm.titlePopUp = "Adicionar novo profissional";
      vm.countAddSpecialtyDoctor = 0;
      vm.doctorAddTemp = {};
      vm.doctorAttendanceDataAdd = [];
    },
    handleSelected(tr) {
      const vm = this;
      vm.disabledConfirmButton = false;
      vm.doctorId = tr.id;
      vm.doctorSelected = tr;
    },
    deleteDoctor(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "clinic-doctors/" + id, {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          if (response.status === 204) {
            vm.getDoctors();
            vm.$swal({
              title: "Sucesso",
              text: "Profissional desvinculado com sucesso!",
              icon: "success"
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Ocorreu um erro",
            text: "O profissional não pode ser removido. Contate o administrador",
            icon: "error"
          });
        });
    },
    confirmDoctor() {
      const vm = this;

      vm.axios
        .post(
          vm.$store.state.filooServer + "clinic-doctors/doctors/" + vm.doctorId,
          vm.doctorSelected,
          {
            headers: {
              Authorization: vm.$session.get("bearer")
            }
          }
        )
        .then(function(response) {
          if (response.status === 201) {
            vm.getDoctors();
            vm.popupAddLinkedDoctor = false;
            vm.$swal({
              title: "Profissional adicionado com sucesso",
              text:
                "O(a) profissional foi adicionado e irá receber uma solicitação, ao aceitar a mesma ele (a) poderá realizar consultas em nome da clínica.",
              icon: "success"
            });
          }
        })
        .catch(function() {
          vm.$vs.notify({
            title: "Ocorreu um erro",
            text: "O profissional não pode ser adicionado. Contate o administrador",
            color: "danger",
            icon: "error"
          });
        });
    },
    validateAdditionDoctor() {
      const vm = this;
      let validFields = true;
      let specialtiesNull = false;
      let hourValid = true;
      let weekDaysValid = true;
      let valueMinAppointmentValid = true;
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.name)) {
        validFields = false;
        vm.$vs.notify({
          title: "Atenção",
          text: "O campo nome é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
      }
      if (vm.validateCPF(vm.doctorAddTemp.cpf) == false && vm.popupIsEditDoctor !== true) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Digite um CPF válido",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.validateEmail(vm.doctorAddTemp.email) == false) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Digite um e-mail válido",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.crmNumber)) {
        vm.$vs.notify({
          title: "Atenção",
          text: "O campo Conselho Regional é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.crmState)) {
        vm.$vs.notify({
          title: "Atenção",
          text: "O campo Estado é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      for (let d in vm.doctorAttendanceDataAdd) {
        if (
          vm.isHour(vm.doctorAttendanceDataAdd[d].initial) == false ||
          vm.isHour(vm.doctorAttendanceDataAdd[d].end) == false
        ) {
          if (vm.doctorAttendanceDataAdd[d].notSchedule !== true) {
            hourValid = false;
          }
        }
        if (vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[d].price)) {
          if (vm.doctorAttendanceDataAdd[d].notSchedule !== true)
            valueMinAppointmentValid = false;
        }
        if (vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[d].days)) {
          if (vm.doctorAttendanceDataAdd[d].notSchedule !== true)
            weekDaysValid = false;
        }
        if (
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[d].specialty)
        ) {
          specialtiesNull = true;
        }
      }
      if (hourValid == false) {
        vm.$vs.notify({
          title: "Atenção",
          text:
            "Os campos de horário são obrigatórios, adicione um horário válido e tente novamente",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (valueMinAppointmentValid == false) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Digite um valor mínimo para a consulta",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (weekDaysValid == false) {
        vm.$vs.notify({
          title: "Atenção",
          text:
            "Selecione ao menos um dia da semana para o atendimento clínico",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (specialtiesNull == true || vm.countAddSpecialtyDoctor == 0) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Adicione ao menos uma especialidade",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }

      if (validFields == true) {
        if (vm.popupIsEditDoctor !== true) {
          vm.confirmAdditionDoctor();
        } else {
          vm.saveChangesDoctor();
        }
      }
    },
    isHour(hour) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(hour)) {
        return false;
      } else {
        let hourArray = hour.split(":");
        let partOne = hourArray[0];
        let parttTwo = hourArray[1];
        let intPartOne = parseFloat(partOne);
        let intPartTwo = parseFloat(parttTwo);
        if (intPartOne > 23 || intPartTwo > 59) {
          return false;
        } else {
          return true;
        }
      }
    },
    getDoctors() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "clinic-doctors/doctors", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.doctorsTemp = response.data.content;
            vm.doctorsAdd = Array.from(
              new Set(vm.doctorsTemp.map(x => x.attendances))
            );
            vm.specialtiesDoctorTable = Array.from(
              new Set(vm.doctorsAdd.map(x => x))
            );
            for(let d in vm.doctorsTemp){
                vm.doctorsTemp[d].technicalManager =  vm.doctorsTemp[d].technicalManager;
                vm.doctorsTemp[d].nameDoctor =  vm.doctorsTemp[d].doctor.name;
                vm.doctorsTemp[d].crmNumberDoctor = vm.doctorsTemp[d].doctor.crmNumber;
                vm.doctorsTemp[d].crmStateDoctor = vm.doctorsTemp[d].doctor.crmState !== null ? "- " + vm.doctorsTemp[d].doctor.crmState.toUpperCase() : "";
                if(vm.doctorsTemp[d].technicalManager === true) {
                  vm.actualTechnicalManager = vm.doctorsTemp[d];
                }

            }
          }
        });
    },
    confirmAdditionDoctor() {
      const vm = this;
      let specialties = [];
      let attendancesFinal = [];
      if (vm.newDoctorsAdd) {
        vm.newDoctorsAdd.shift();
      }
      for (let d in vm.doctorAttendanceDataAdd) {
        specialties.push(vm.doctorAttendanceDataAdd[d].specialty);
        vm.doctorAttendanceDataAdd[d].price =
          vm.doctorAttendanceDataAdd[d].notSchedule == true
            ? null
            : vm.doctorAttendanceDataAdd[d].price.replace(",", ".");
        attendancesFinal.push({
          webClinicId: vm.$session.get("clinicId"),
          ignoreMatch:
            vm.doctorAttendanceDataAdd[d].notSchedule !== true ? false : true,
          price:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].price.replace(",", "."),
          initial:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].initial,
          end:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].end,
          days:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].days,
          specialty: vm.doctorAttendanceDataAdd[d].specialty
        });
      }

      let doctor = {
        name: vm.doctorAddTemp.name,
        crmNumber: vm.doctorAddTemp.crmNumber,
        crmState: vm.doctorAddTemp.crmState,
        email: vm.doctorAddTemp.email,
        cpf: vm.doctorAddTemp.cpf,
        attendances: attendancesFinal,
        specialties: specialties
      };
      vm.newDoctorsAdd.push(new Object(doctor));
      vm.putNewDoctor();
    },
    addSpecialtyDoctor() {
      const vm = this;
      vm.countAddSpecialtyDoctor += 1;
      setTimeout(function() {
        vm.doctorAttendanceDataAdd.push([]);
      }, 700);
    },
    removeSpecialtyDoctor(index) {
      const vm = this;
      vm.countAddSpecialtyDoctor -= 1;
      setTimeout(function() {
        vm.doctorAttendanceDataAdd.splice(index, 1);
      }, 700);
    },
    getSpecialties() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "specialties", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        });
    },
    getDoctorsAfterSearch() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "/admin/doctors?page=0&search=" +
            vm.typedWord +
            "&size=10&sort=id,asc",
          {
            headers: {
              Authorization: vm.$session.get("bearer")
            }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.doctorsSearch = response.data.content;
          }
        });
    },
    clickAddLinkedDoctor() {
      const vm = this;
      vm.popupAddLinkedDoctor = true;
      vm.doctorsSearch = [];
      vm.typedWord = "";
    },
    editDoctor(data) {
      const vm = this;
      let doctor = data.doctor;
      vm.titlePopUp = "Gerenciar especialidades: " + doctor.name;
      vm.popupIsEditDoctor = true;
      vm.doctorAddTemp.name = doctor.name;
      vm.doctorAddTemp.crmNumber = doctor.crmNumber;
      vm.doctorAddTemp.crmState = doctor.crmState;
      vm.doctorAddTemp.email = doctor.email;
      vm.doctorAddTemp.cpf = doctor.cpf;
      vm.doctorAttendanceDataAdd = data.attendances;
      vm.webClinic = data;
      for (let a in data.attendances) {
        vm.countAddSpecialtyDoctor += 1;
        vm.specialties[a] = data.attendances[a].specialty;
        vm.doctorAttendanceDataAdd[a].specialty = data.attendances[a].specialty;
        vm.doctorAttendanceDataAdd[a].price = vm.maskMoneyWithoutStyle(
          data.attendances[a].price
        );
      }
      vm.popupAddDoctor = true;
    },
    saveChangesDoctor() {
      const vm = this;
      vm.webClinic.doctor.name = vm.doctorAddTemp.name;
      vm.webClinic.doctor.crmNumber = vm.doctorAddTemp.crmNumber;
      vm.webClinic.doctor.crmState = vm.doctorAddTemp.crmState;
      vm.webClinic.doctor.cpf = vm.doctorAddTemp.cpf;
      vm.webClinic.doctor.email = vm.doctorAddTemp.email;
      for(let a in vm.doctorAttendanceDataAdd){
        vm.doctorAttendanceDataAdd[a].price = vm.doctorAttendanceDataAdd[a].price.replace(",", ".");
      }
      let attendancesFinal = [];
      for (let d in vm.doctorAttendanceDataAdd) {
        attendancesFinal.push({
          webClinicId: vm.$session.get("clinicId"),
          ignoreMatch:
            vm.doctorAttendanceDataAdd[d].notSchedule !== true ? false : true,
          price:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].price.replace(",", "."),
          initial:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].initial,
          end:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].end,
          days:
            vm.doctorAttendanceDataAdd[d].notSchedule == true
              ? null
              : vm.doctorAttendanceDataAdd[d].days,
          specialty: vm.doctorAttendanceDataAdd[d].specialty
        });
      }
      let changes = {
        id: vm.webClinic.id,
        webClinic: {
          id: vm.webClinic.webClinic.id,
          cnpj: vm.webClinic.webClinic.cnpj,
          name: vm.webClinic.webClinic.name,
          socialName: vm.webClinic.webClinic.socialName,
          legalRepresentative: vm.webClinic.webClinic.legalRepresentative,
          phone: vm.webClinic.webClinic.phone,
          contactEmail: vm.webClinic.webClinic.contactEmail,
          partner: vm.webClinic.webClinic.partner,
          address: vm.webClinic.webClinic.address,
          assistants: vm.webClinic.webClinic.assistants,
          active: vm.webClinic.webClinic.active,
          countDoctors: vm.webClinic.webClinic.countDoctors
        },
        doctor: vm.webClinic.doctor,
        accept: vm.webClinic.accept,
        mainAttendance: vm.webClinic.mainAttendance,
        attendances: attendancesFinal
      };
        vm.axios
          .put(
            vm.$store.state.filooServer +
              "doctor/clinic-doctors/" +
              vm.webClinic.id,
            changes,
            {
              headers: { Authorization: vm.$session.get("bearer") }
            }
          )
          .then(function(response) {
            vm.popupAddDoctor = false;
            if (response.status === 200) {
              vm.popupIsEditDoctor = false;
              vm.$swal({
                title: "Sucesso!",
                text: "Alterações realizadas com sucesso.",
                icon: "success"
              }).then(function() {
                vm.getDoctors();
              });
            }
          })
          .catch(function() {
              vm.popupIsEditDoctor = false;
          });
    },
    putNewDoctor() {
      const vm = this;
      let doctor = {
        webClinicId: vm.$session.get("clinicId"),
        name: vm.newDoctorsAdd[0].name,
        crmNumber: vm.newDoctorsAdd[0].crmNumber,
        crmState: vm.newDoctorsAdd[0].crmState,
        cpf: vm.newDoctorsAdd[0].cpf,
        email: vm.newDoctorsAdd[0].email,
        specialties: vm.newDoctorsAdd[0].specialties,
        attendances: vm.newDoctorsAdd[0].attendances
      };
      vm.axios
        .post(vm.$store.state.filooServer + "signup/doctor-from-clinic", doctor)
        .then(function(response) {
          vm.popupAddDoctor = false;
          if (response.status === 201) {
            vm.$swal({
              title: "Sucesso!",
              text: "Cadastro realizado com sucesso.",
              icon: "success"
            }).then(function() {
              vm.getDoctors();
            });
          }
        })
        .catch(function(error) {
          vm.newDoctorsAdd = [];
          if (
            error.response.data.message === "exception.user.already.exist.email"
          ) {
            vm.$vs.notify({
              title: "Atenção!",
              text:
                "E-mail já utilizado, verifique se o profissional já possui cadastro ou digite um novo e-mail",
              color: "warning",
              position: "top-right",
              icon: "error",
              time: 6000
            });
          }
        });
    },
    makeTechincalManager(id) {
        const vm = this;

        vm.axios.get(vm.$store.state.filooServer + "webclinics/techmanager/" + id.webClinic.id + "/" + id.doctor.id,
        {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Atualizado com sucesso.",
              icon: "success"
            }).then(function () {
              vm.getDoctors();
            });
          }
        });
    },

  }
}
</script>

<style lang="scss" src="./TechnicalManager.scss">
</style>
